export default {
  "avatar": "_avatar_12yli_1",
  "image": "_image_12yli_15",
  "squared": "_squared_12yli_25",
  "xs": "_xs_12yli_29",
  "sm": "_sm_12yli_35",
  "md": "_md_12yli_26",
  "lg": "_lg_12yli_47"
};import "ni:sha-256;24cutxzDN648ve6GnemSH4YzL0jHLmj4R9ULfb6u1aM";